import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    padding: 20px;
    margin-right: auto;
    margin-left: auto;
    overflow: hidden;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 20px;
`;

export const Cartao = styled.section`
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    height: auto;
    color: ${(props: any) => props.theme.colors.interfaceText400};
    word-wrap: break-word;
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    background-clip: border-box;
    border: none;
    border-radius: 8px;
    padding: 17px 21px;
    margin-bottom: 24px;
`;

export const CartaoNavegacao = styled(Cartao)`
    padding: 0.5rem !important;
    border-radius: 0 !important;
    grid-column: span 12 !important;
    margin-bottom: 0;
`;

export const SecaoConteudo = styled.div`
    grid-column: span 12 !important;
`;

export const TituloAcoes = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: auto;

    @media (max-width: 768px) {
        margin-left: 0;
        width: 100%;
        margin-top: 8px;
    }
`;

export const Titulo = styled.h3`
    color: ${({ theme }) => theme.colors.interfaceText};
    display: flex;
    font-size: 18px;
    font-weight: 600;
    gap: 8px;
    letter-spacing: -0.45px;
    line-height: 28px;
    margin-bottom: 8px;
    align-items: center;
    flex-wrap: wrap;

    svg {
        display: inline-block;
        vertical-align: middle;
        flex-shrink: 0;
    }

    @media (max-width: 768px) {
        ${TituloAcoes} {
            width: 100%;
            margin-left: 0;
            margin-top: 8px;
        }
    }
`;

export const Conteudo = styled.div`
    &:last-child {
        margin-bottom: 0;
    }
`;

export const Rotulo = styled.label`
    display: block;
    color: ${(props: any) => props.theme.colors.c64748b};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin: 0px 0px 8px 0px;
`;

export const ValorDestacado = styled.p`
    background-color: ${(props: any) => props.theme.colors.cf1f5f94d};
    border-color: ${(props: any) => props.theme.colors.ce2e8f0};
    border-radius: 6px;
    border-style: solid;
    border-width: 1px;
    color: ${({ theme }) => theme.colors.interfaceText};
    font-size: 14px;
    line-height: 20px;
    padding: 12px;
    margin-bottom: 16px;
`;

export const Divisor = styled.hr`
    margin: 8px 0;
    border: 0;
    border-top: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
`;

export const Rodape = styled.small`
    font-size: 12px;
    line-height: 16px;
`;

export const Arquivo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border: 1px solid ${(props: any) => props.theme.colors.interfaceBorder100};
    border-radius: 8px;
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${(props: any) => props.theme.colors.cf8f9fa};
    }
`;

export const ArquivoIcone = styled.div`
    flex-shrink: 0;
`;

export const ArquivoConteudo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const ArquivoNome = styled.p`
    color: ${(props: any) => props.theme.colors.c1e293b};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin: 0 0 4px 0;
    word-break: break-word;
`;

export const ArquivoTamanho = styled.p`
    color: ${(props: any) => props.theme.colors.c64748b};
    font-size: 12px;
    line-height: 16px;
    margin: 0;
`;

export const ArquivoAcao = styled.div`
    flex-shrink: 0;
`;

export const Timestamp = styled.span`
  color: ${(props: any) => props.theme.colors.c64748b};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Botao = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    border: 1px solid transparent;
    cursor: pointer;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
    user-select: none;
    text-align: center;
`;

export const BotaoPrimario = styled(Botao)`
    background-color: ${(props: any) => props.theme.colors.primaryRed400};
    border-color: ${(props: any) => props.theme.colors.primaryRed400};
    color: ${(props: any) => props.theme.colors.pureWhite};

    &:hover {
        background-color: ${(props: any) => props.theme.colors.cc9243a};
        border-color: ${(props: any) => props.theme.colors.cc9243a};
    }
`;

export const BotaoMuted = styled(Botao)`
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    border-color: ${(props: any) => props.theme.colors.interfaceBorder100};
    color: ${(props: any) => props.theme.colors.c1e293b};

    &:hover {
        background-color: ${(props: any) => props.theme.colors.cf8f9fa};
    }
`;

export const BotaoIcone = styled.span`
    display: inline-flex;
`;

export const CampoTexto = styled.textarea`
    width: 100%;
    padding: 12px;
    border: 1px solid ${(props: any) => props.theme.colors.interfaceBorder100};
    border-radius: 8px;
    font-size: 14px;
    line-height: 20px;
    font-family: inherit;
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    outline: none;
    resize: vertical;
    color: ${({ theme }) => theme.colors.interfaceText};
`;

export const Linha = styled.div<{ $centralizado?: boolean }>`
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: flex-start;
  flex-wrap: wrap;
  ${({ $centralizado }) => $centralizado && `justify-content: center !important;`}
`;

export const Coluna = styled.div`
  flex: 1;
  min-width: 220px;
`;

export const Selo = styled.span<{ status?: string }>`
  display: inline-flex !important;
  background-color: ${({ status }) => status === "Ciente" ? "var(--cf0fdf4)" : "var(--cfefce8)"} !important;
  color: ${({ status }) => status === "Ciente" ? "var(--c166534)" : "var(--ca16207)"} !important;
  border: 1px solid ${({ status }) => status === "Ciente" ? "var(--cbbf7d0)" : "var(--cfef08a)"} !important;
  font-weight: 600;
  padding: 2px 10px;
  align-items: center;
  gap: 2px;
  border-radius: 9999px;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
`;

export const NavegacaoSecao = styled.span`
  color: ${({ theme }) => theme.colors.interfaceText300};
  cursor: pointer;
  transition: color 0.2s ease;
  &:hover {
    color: ${(props: any) => props.theme.colors.c64748b};
  }
`;